import * as yup from 'yup';
import { trimmedInputValues } from '../utils';

const vmiContractItemValidation = yup.object().shape({
    companyId: yup.number().required("Please enter company"),
    warehouseId: yup.number().required("Please enter warehouse"),
    // companyERPCode: yup.string()
    //     .transform((value) => trimmedInputValues(value))
    //     .required('Please enter ERP Code'),
    safetyStock: yup.number().required("Please enter Minimum Stock Qty"),
    permMaterialId: yup.number().required("Please enter perm material Id"),
    orderingThresholdQty: yup.number().required("Please enter Ordering Threshold Qty"),
})

const vmiContractItemsBulkUploadValidation = yup.array().of(
    yup.object().shape({
        // companyERPCode: yup.string()
        // .transform((value) => trimmedInputValues(value))
        // .required('Please enter company ERP Code'),
        permMaterialId: yup.number().required('Please enter perm material Id'),
        orderingThresholdQty: yup.number().required("Please enter Ordering Threshold Qty")
    })
)

const vmiContractItemInitialState = {
    companyId: null,
    warehouseId: null,
    companyERPCode: null,
    permMaterialId: null,
    safetyStock: null,
    orderingThresholdQty: null,
    orderQty: null,
    targetStockQty: null
}

const vmiContractItemsBulkUploadInitialState = {
    companyERPCode: null,
    permMaterialId: null,
    safetyStock: null,
    orderingThresholdQty: null,
    orderQty: null,
    targetStockQty: null
}

export { 
    vmiContractItemValidation, 
    vmiContractItemInitialState,
    vmiContractItemsBulkUploadInitialState,
    vmiContractItemsBulkUploadValidation
};